import { Stack } from '@mui/material';
import { WsTypography, WsTypoColors, WsTypoVariants } from 'wisestep-base';

import { extractEmail } from '../helper';

export const FromLabel = ({ label, handleContent }) =>
  handleContent.content ? (
    <Stack direction="row" justifyContent="flex-start">
      <WsTypography color={WsTypoColors.SENARY} variant={WsTypoVariants.BODY1}>
        {label} : {extractEmail(handleContent.content.from).email}
      </WsTypography>
    </Stack>
  ) : (
    <></>
  );
